import { Facility } from '@reliance/types/models/Facility';
import React from 'react';
import Card from 'react-bootstrap/Card';
import { formatTaxTableDescription } from '../format/TaxTableDescription';

type TaxesProps = {
  facility: Facility;
};

const Taxes: React.FC<TaxesProps> = (props) => {
  return (
    <Card>
      <Card.Header>Taxes</Card.Header>
      <Card.Body>
        <div>City Tax: <br/>{formatTaxTableDescription(props.facility.cityTax)}</div>
        <div className="mt-1">State Tax: <br/>{formatTaxTableDescription(props.facility.stateTax)}</div>
        <div className="mt-1">Federal Tax: <br/>{formatTaxTableDescription(props.facility.fedTax)}</div>
        <div className="mt-1">FUSF Tax: <br/>{formatTaxTableDescription(props.facility.usfTax)}</div>
        <div className="mt-1">TRS Charge: <br/>{formatTaxTableDescription(props.facility.trsTax)}</div>
        <div className="mt-1">FCC Rate Additive: <br/>{formatTaxTableDescription(props.facility.fssfTax)}</div>
      </Card.Body>
    </Card>
  );
};

export default Taxes;
